import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, input, OnChanges, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CardItem } from '@components/partials/card-item/card-item';
import { UiModule } from '@components/ui/ui-module';
import { CardBinder, Page, Scan, UserBinder } from '@models/binder.model';
import { Card, CardPrice } from '@models/card.model';
import { BinderService } from '@services/binder.service';
import { Router } from '@services/route.service';
import { ScannerService } from '@services/scanner.service';
import { SettingService } from '@services/setting.service';

@Component({
  selector: 'lgb-binder-card-list',
  imports: [
    CommonModule,
    RouterModule,
    UiModule,
    CardItem,
    FormsModule
  ],
  templateUrl: './binder-card-list.html',
  styleUrl: './binder-card-list.css',
})
export class BinderCardList {
  //services
  readonly router=inject(Router);
  readonly route=inject(ActivatedRoute);
  readonly scanService=inject(ScannerService);
  readonly binderS=inject(BinderService);
  readonly settings=inject(SettingService);

  //data
  readonly uBinder=input.required<UserBinder | null>();
  readonly cards=input.required<CardBinder[]>();
  readonly scans=input.required<Scan[]>();
  readonly references=input.required<Card[]>();
  readonly backHisto=input(false);
  readonly share=input<string>(null);
  readonly pages=input<Page[]>(null);
  readonly admin=computed(() => this.share==null);

  //ui
  readonly fragment=signal<string>(null);
  readonly pagesSorted=computed(() => this.getPages());

  constructor(){
    this.route.fragment.subscribe(f => this.fragment.set(f));
  }

  getScan(scan: String){
    if(scan)
      return this.scans().find(s => s.ident==scan);
    else
      return null;
  }

  getRefence(ident: string){
    return this.references().find(c => c.ident==ident);
  }

  getPages(){
    let sorted: OnePage[]=[];
    if(this.pages()){
      this.pages().sort((a: Page, b: Page) => a.index-b.index);
      this.pages().forEach(p => {
        const card: OnePage={
          page: p,
          cards: this.cards().filter(c => c.page==p.ident)
        };
        if(card.cards.length)
          sorted.push(card);
      });
    }

    return sorted;
  }
}

interface OnePage{
  page: Page;
  cards: CardBinder[];
}
